import React, { useEffect } from 'react';
import Table from '../../../modules/components/Table'
import Grid from '@material-ui/core/Grid';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import AddEditStore from './AddEditStore';
import firebase from "firebase";

export default function Index(props) {

    const [headCells, setHeadCells] = React.useState([]);
    const [headMobileCells, setHeadMobileCells] = React.useState([]);
    const [searchValue, setSearchValue] = React.useState("");
    const [searchCell, setSearchCell] = React.useState([]);
    const [displayInfo, setDisplayInfo] = React.useState([]);
    const [editCells, setEditCells] = React.useState([]);
    const [uploadCells, setUploadCells] = React.useState([]);
    const [addCells, setAddCells] = React.useState([]);
    const [addCellsName, setAddCellsName] = React.useState([]);
    const matches = useMediaQuery(theme => theme.breakpoints.up('sm'));

    useEffect(() => {

        setHeadCells([
           
            { id: 'id', label: 'Store Id' },
            { id: 'store_name', label: 'Store Name' },
            { id: 'first_name', label: 'First Name' },
            { id: 'last_name', label: 'Last Name' },
            { id: 'role', label: 'Role' },
            { id: 'phone', label: 'Phone' },
            { id: 'status_users', label: 'Status' },
        ])

        setHeadMobileCells([
            { id: 'id', label: 'Store Id' },
            { id: 'first_name', label: 'First Name' },
            { id: 'last_name', label: 'Last Name' },
        ])
    
        setSearchCell([
            { id: 'id', label: 'Phone' },
            { id: 'email', label: 'Email' },
        ])

        setDisplayInfo([
            { id: 'id', label: 'Store Id' },
            { id: 'store_name', label: 'Store Name' },
            { id: 'store_address', label: 'Store Address' },
            { id: 'ssm_id', label: 'SSM ID' },
            { id: 'first_name', label: 'First Name' },
            { id: 'last_name', label: 'Last Name' },
            { id: 'role', label: 'Role' },
            { id: 'created', label: 'Registered' },
            { id: 'phone', label: 'Phone' },
            { id: 'status_users', label: 'Status' },
            { id: 'image1', label: 'Image 1' },
            { id: 'image2', label: 'Image 2' },
            { id: 'image3', label: 'Image 3' },
            { id: 'image4', label: 'Image 4' },
        ])

        setEditCells([
            { id: 'store_name', label: 'Store Name' },
            { id: 'ssm_id', label: 'SSM ID' },
            { id: 'first_name', label: 'First Name' },
            { id: 'last_name', label: 'Last Name' },
            { id: 'store_address', label: 'Store Address' },
            { id: 'phone', label: 'Phone' },
            
        ])

        setUploadCells([
            { id: 'image1', label: 'Image 1' },
            { id: 'image2', label: 'Image 2' },
            { id: 'image3', label: 'Image 3' },
            { id: 'image4', label: 'Image 4' },
            
        ])

        setAddCells([
            { id: 'id', label: 'Store Id' },
            { id: 'store_name', label: 'Store Name' },
            { id: 'store_address', label: 'Store Address' },
            { id: 'ssm_id', label: 'SSM ID' },
            { id: 'first_name', label: 'First Name' },
            { id: 'last_name', label: 'Last Name' },
            { id: 'status_users', label: 'Status' },
            { id: 'address', label: 'Address' },
        ])

        setAddCellsName({ 
            id: '',
            store_address: '',
            first_name: '',
            last_name: '',
            point_users: '',
            total_ordered_products: '',
            created: firebase.database.ServerValue.TIMESTAMP,
            updated: firebase.database.ServerValue.TIMESTAMP,
            email: '',
            phone: '',
            status_users: '',
            role: '',
            user_redeem_time: ''
         })
    
        setSearchValue("phone")
        
    }, []);

    return (
    <Grid>
        <Table 
            {...props}
            customizeDialog={AddEditStore}
            control={true}
            orderBy="created" 
            data="users" 
            addItemButton={false}
            addItemText="Add Users"
            addItemIcon={<AddCircleIcon/>}
            addCells={addCells}
            addCellsName={addCellsName}
            uploadCells={uploadCells}
            folder_data="users_zone"
            displayInfo={displayInfo}
            editCells={editCells}
            matches={matches}
            headCells={matches ? headCells : headMobileCells} 
            searchValue={searchValue} 
            searchCell={searchCell}/>
    </Grid>
    )

}
  